import add from "./add.png";
import finish from "./finish.png";
import search from "./search.png";
import searchGreen from "./searchGrenn.png";
import teamwork from "./teamwork.png";
import validation from "./validation.png";
import logo from "./logo.png";
import panda from "./panda.jpg";
import trash from "./delete.png";
import group from "./group.png";
import group3 from "./group3.png";
import audioJack from "./audioJack.png";
import cabriolet from "./cabriolet.png";
import controller from "./controller.png";
import gps from "./gps.png";
import heat from "./heat.png";
import record from "./record.png";
import medal from "./medal-1.png";
import processing from "./processing.png";
import carPhoto from "./carPhoto.jpg";
import carPhoto2 from "./carPhoto2.jpg";
import carPhoto3 from "./carPhoto3.jpg";
import carPhoto4 from "./carPhoto4.jpg";
import carPhoto5 from "./carPhoto5.jpeg";
import confirm from "./confirm.png";
import confirmStatus from "./confirm-status.png";
import leftArrow from "./left-arrow.png";
import close from "./close.png";
import avatar from "./avatar.jpg";
import returnArrow from "./return-arrow.png";
import whiteClose from "./white-close.png";
import gpsOn from "./feature1.png";
import controllerOn from "./feature2.png";
import recordOn from "./feature3.png";
import audioOn from "./feature4.png";
import usbOn from "./feature5.png";
import bluetoothOn from "./feature6.png";
import medalOn from "./feature7.png";
import cabrioletOn from "./feature8.png";
import carOn from "./feature9.png";
import heatOn from "./feature10.png";
import tireOn from "./feature11.png";
import chassisOn from "./feature12.png";
import EditIcon from "@material-ui/icons/Edit";

export const images = {
  whiteClose,
  add,
  EditIcon,
  logo,
  gpsOn,
  heatOn,
  tireOn,
  chassisOn,
  close,
  medalOn,
  carOn,
  cabrioletOn,
  controllerOn,
  recordOn,
  confirmStatus,
  returnArrow,
  audioOn,
  bluetoothOn,
  usbOn,
  avatar,
  audioJack,
  cabriolet,
  controller,
  leftArrow,
  gps,
  confirm,
  carPhoto,
  carPhoto2,
  carPhoto3,
  carPhoto4,
  carPhoto5,
  heat,
  record,
  medal,
  group3,
  finish,
  search,
  teamwork,
  validation,
  panda,
  trash,
  processing,
  group,
  searchGreen
};
